export default {
  TRIAL_SIGNUP: "TRIAL_SIGNUP",
  ARENA_SIGNUP: "ARENA_SIGNUP",
  ONGOING: "ONGOING",
  CUSTOMIZED: "CUSTOMIZED",
  COMPLETED: "COMPLETED",
}